import { Minute } from '@nu-art/ts-common';
import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_EHREmulator = {
    _v1: {
        getEventsWithSimulations: { method: HttpMethod.POST, path: '/v1/ehr-emulator/get-events-with-simulations', timeout: Minute },
        getEventsWithSimulationsByEncounterId: { method: HttpMethod.POST, path: '/v1/ehr-emulator/get-events-with-simulations-by-encounter-id', timeout: Minute },
        getBucketsForEvent: { method: HttpMethod.POST, path: '/v1/ehr-emulator/get-buckets-for-event', timeout: Minute },
        getEventsWithSimulationsByFilters: { method: HttpMethod.POST, path: '/v1/ehr-emulator/get-events-with-simulations-by-filters', timeout: Minute },
        downloadBugReportFile: { method: HttpMethod.POST, path: '/v1/ehr-emulator/download-bug-report-file', timeout: Minute },
    },
};
//# sourceMappingURL=api-def.js.map